import { SmartQFreeMoveEvent, SmartQGroupEvent } from "./SmartQEvent" // eslint-disable-line no-unused-vars

export const defaultOptions = {
  groups: [],
  groupSelectedIndex: null,
  selected: [],
}

export default class SmartQDraggableFree {
  // eslint-disable-line no-unused-vars
  constructor(draggable) {
    this.draggable = draggable

    this.options = {
      ...defaultOptions,
      ...this.getOptions(),
    }

    this.elements = []
    this.mirror = null
    this.associatedMirrors = []
    this.selectedMirrors = []
    this.mirrorOptions = {
      constrainDimensions: false,
      xAxis: true,
      yAxis: true,
      cursorOffsetX: null,
      cursorOffsetY: null,
      thresholdX: null,
      thresholdY: null,
    }
    this.initialMousePosition = {}
    this.scrollContainer = null
    this.initialScrollOffset = {}
    this.scrollOffset = {}
    this.mirrorOffset = {}
    this.isSourceSuperImposed = false
    this.superImposedElements = []
    this.topLeft = {
      top: 100000,
      left: 100000,
      element: null,
    }

    this.onMirrorCreated = this.onMirrorCreated.bind(this)
    this.onMirrorMove = this.onMirrorMove.bind(this)
    this.onDragStart = this.onDragStart.bind(this)
    this.onDragStop = this.onDragStop.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  getOptions() {
    return this.draggable.options.smartq || {}
  }

  attach() {
    this.draggable
      .on("drag:start", this.onDragStart)
      .on("mirror:created", this.onMirrorCreated)
      .on("mirror:move", this.onMirrorMove)
      .on("drag:stop", this.onDragStop)
  }

  detach() {
    this.draggable
      .off("drag:start", this.onDragStart)
      .off("mirror:created", this.onMirrorCreated)
      .off("mirror:move", this.onMirrorMove)
      .off("drag:stop", this.onDragStop)
  }

  onDragStart(dragEvent) {
    // avoid dragging other elements when a group is selected
    if (
      this.options.groups.length > 0 &&
      this.options.groupSelectedIndex !== null &&
      this.options.groups[this.options.groupSelectedIndex] &&
      !this.options.groups[this.options.groupSelectedIndex].includes(parseInt(dragEvent.source.firstElementChild.id))
    ) {
      dragEvent.cancel()
      return
    }

    // avoid dragging other elements when a selection exists
    if (
      this.options.selected.length &&
      !this.options.selected.includes(parseInt(dragEvent.source.firstElementChild.id))
    ) {
      dragEvent.cancel()
      return
    }

    // initialiaze properties
    this.elements = this.draggable.getDraggableElementsForContainer(dragEvent.sourceContainer)
    this.initialMousePosition = {
      x: dragEvent.sensorEvent.clientX,
      y: dragEvent.sensorEvent.clientY,
    }
    this.scrollContainer = document.getElementById("grid-container")
    this.initialScrollOffset = {
      x: this.scrollContainer.scrollLeft,
      y: this.scrollContainer.scrollTop,
    }
    this.scrollContainer.addEventListener("scroll", this.onScroll, true)

    // remove all groups top left icon
    /*if (this.options.groups.length && !this.options.selected.length) {
      this.options.groups.map(group => {
        group.map(index => {
          this.elements[index].firstElementChild.firstElementChild.classList.remove('bloc-group-icon--is-visible')
        })
      })
    }*/

    // group drag
    if (
      this.options.groups.length &&
      this.groupSelectedIndex !== null &&
      this.options.groups[this.options.groupSelectedIndex] &&
      this.options.groups[this.options.groupSelectedIndex].includes(parseInt(dragEvent.source.firstElementChild.id))
    ) {
      // create mirrors for all group elements => associatedMirrors
      // except the dragging mirror which is automatically created
      this.options.groups[this.options.groupSelectedIndex].map((id) => {
        if (parseInt(dragEvent.source.firstElementChild.id) === id) {
          return
        }

        const associatedOriginalSource = document.getElementById(id).parentElement
        const associatedSource = associatedOriginalSource.cloneNode(true)

        associatedOriginalSource.parentNode.insertBefore(associatedSource, associatedOriginalSource)
        associatedOriginalSource.style.display = "none"

        this.associatedMirrors.push({
          mirror: associatedSource.cloneNode(true),
          source: associatedSource,
          originalSource: associatedOriginalSource,
          state: {},
        })

        associatedOriginalSource.classList.add(this.draggable.getClassNameFor("source:original"))
        associatedSource.classList.add(this.draggable.getClassNameFor("source:dragging"))
      })
    } else if (this.options.selected.length > 1) {
      // multi select drag
      this.options.selected.map((id) => {
        if (parseInt(dragEvent.source.firstElementChild.id) === id) {
          return
        }
        const selectedOriginalSource = document.getElementById(id).parentElement
        const selectedSource = selectedOriginalSource.cloneNode(true)

        selectedOriginalSource.parentNode.insertBefore(selectedSource, selectedOriginalSource)
        selectedOriginalSource.style.display = "none"

        this.selectedMirrors.push({
          source: selectedSource,
          originalSource: selectedOriginalSource,
        })

        selectedOriginalSource.classList.add(this.draggable.getClassNameFor("source:original"))
        selectedSource.classList.add(this.draggable.getClassNameFor("source:dragging"))
      })
    }
  }

  onMirrorCreated({ mirror, sensorEvent, sourceContainer }) {
    // eslint-disable-line no-unused-vars
    // position main mirror over all other elements
    mirror.style.zIndex = 11000
    this.mirror = mirror

    // group drag
    if (this.associatedMirrors.length) {
      this.associatedMirrors.map(({ mirror, source, state }) => {
        // position all associated mirrors over all other elements but under the main mirror (11000)
        // preserve old positions by adding 10000 to old zIndex
        if (mirror.style.zIndex) {
          mirror.style.zIndex = parseInt(mirror.style.zIndex) + 10000
        } else {
          mirror.style.zIndex = 10000
        }

        const setState = ({ mirrorOffset, initialX, initialY }) => {
          state.mirrorOffset = mirrorOffset
          state.initialX = initialX
          state.initialY = initialY
          state.lastMovedX = initialX
          state.lastMovedY = initialY
        }

        const initialState = {
          mirror,
          source,
          sensorEvent,
          mirrorClass: this.draggable.getClassNameFor("mirror"),
          scrollOffset: this.scrollOffset,
          options: this.mirrorOptions,
          passedThreshX: true,
          passedThreshY: true,
        }

        Promise.resolve(initialState)
          .then(computeMirrorDimensions)
          .then(calculateMirrorOffset)
          .then(resetMirror)
          .then(addMirrorClasses)
          .then(positionMirror({ initial: true }))
          .then(removeMirrorID)
          .then(setState)

        sourceContainer.appendChild(mirror)
      })
    } else {
      mirror.classList.remove("bloc--is-superimposed")
      // multi select drag
      if (this.options.selected.length > 1) {
        mirror.getElementsByClassName("bloc-selected-count")[0].classList.add("bloc-selected-count--is-visible")
      }
    }
  }

  onScroll() {
    this.scrollOffset = {
      x: this.scrollContainer.scrollLeft - this.initialScrollOffset.x,
      y: this.scrollContainer.scrollTop - this.initialScrollOffset.y,
    }
  }

  onMirrorMove({ source, mirror, sensorEvent }) {
    // eslint-disable-line no-unused-vars
    requestAnimationFrame(() => {
      const offsetX = sensorEvent.clientX - this.initialMousePosition.x
      const offsetY = sensorEvent.clientY - this.initialMousePosition.y

      this.mirrorOffset = {
        top: offsetY,
        left: offsetX,
      }

      // no group drag and no multi select drag
      if (!this.associatedMirrors.length && this.options.selected.length <= 1) {
        // find all super imposed elements
        this.superImposedElements = getSuperImposedElements({ mirror, source, elements: this.elements })

        if (this.superImposedElements.length) {
          this.isSourceSuperImposed = true
          mirror.classList.add("bloc--is-superimposed")
        } else {
          this.isSourceSuperImposed = false
          mirror.classList.remove("bloc--is-superimposed")
        }

        // remove top left group icon
        if (this.topLeft.element) {
          this.topLeft.element.firstElementChild.firstElementChild.classList.remove("bloc-group-icon--is-visible")
          this.topLeft = {
            top: 100000,
            left: 100000,
            element: null,
          }
        }

        this.elements.map((elt) => {
          if (this.superImposedElements.includes(elt)) {
            elt.classList.add("bloc--is-superimposed")

            // find top left element
            let eltRect = elt.firstElementChild.getBoundingClientRect()
            if (eltRect.top < this.topLeft.top) {
              this.topLeft.left = eltRect.left
              this.topLeft.top = eltRect.top
              this.topLeft.element = elt
            } else if (eltRect.top === this.topLeft.top && eltRect.left <= this.topLeft.left) {
              this.topLeft.left = eltRect.left
              this.topLeft.top = eltRect.top
              this.topLeft.element = elt
            }
          } else {
            if (!elt.classList.contains("bloc--is-groupped")) {
              elt.classList.remove("bloc--is-superimposed")
            }
          }
        })

        let mirrorRect = mirror.firstElementChild.getBoundingClientRect()

        // check if mirror is the top left element
        if (mirrorRect.top < this.topLeft.top) {
          this.topLeft.left = mirrorRect.left
          this.topLeft.top = mirrorRect.top
          this.topLeft.element = mirror
        } else if (mirrorRect.top === this.topLeft.top && mirrorRect.left <= this.topLeft.left) {
          this.topLeft.left = mirrorRect.left
          this.topLeft.top = mirrorRect.top
          this.topLeft.element = mirror
        }

        // set top left group icon
        if (this.isSourceSuperImposed && this.topLeft.element) {
          this.topLeft.element.firstElementChild.firstElementChild.classList.add("bloc-group-icon--is-visible")
        }
      } else {
        // group drag
        this.associatedMirrors.map((associatedMirror) => {
          const setState = ({ lastMovedX, lastMovedY }) => {
            associatedMirror.state.lastMovedX = lastMovedX
            associatedMirror.state.lastMovedY = lastMovedY
          }

          const initialState = {
            mirror: associatedMirror.mirror,
            sensorEvent: sensorEvent,
            mirrorOffset: associatedMirror.state.mirrorOffset,
            options: this.mirrorOptions,
            initialX: associatedMirror.state.initialX,
            initialY: associatedMirror.state.initialY,
            scrollOffset: { x: 0, y: 0 }, // !! important to let mirror move with scroll // this.scrollOffset,
            passedThreshX: true,
            passedThreshY: true,
            lastMovedX: associatedMirror.state.lastMovedX,
            lastMovedY: associatedMirror.state.lastMovedY,
          }

          Promise.resolve(initialState)
            .then(positionMirror({ raf: true }))
            .then(setState)
        })
      }
    })
  }

  onDragStop({ originalSource, source }) {
    this.scrollContainer.removeEventListener("scroll", this.onScroll, true)

    // position original source of mirror
    let top =
      parseInt(originalSource.firstElementChild.style.top) +
      this.mirrorOffset.top +
      (this.scrollOffset.y ? this.scrollOffset.y : 0)

    originalSource.firstElementChild.style.top = top + "px"

    let left = parseInt(originalSource.firstElementChild.style.left) + this.mirrorOffset.left

    originalSource.firstElementChild.style.left = left + "px"

    let itemsPosition = []

    itemsPosition.push({
      index: parseInt(originalSource.firstElementChild.id),
      top: top,
      left: left,
    })

    // reset z-index
    this.mirror.style.zIndex = 0

    // update mirror in elements array
    this.elements[parseInt(originalSource.firstElementChild.id)] = this.mirror

    // not in group drag and not in multi select drag
    if (!this.associatedMirrors.length && this.options.selected.length <= 1) {
      let newGroups = []

      if (this.isSourceSuperImposed) {
        originalSource.classList.add("bloc--is-groupped")
        originalSource.classList.add("bloc--is-superimposed")

        // find max zIndex of group's elements
        let maxZindex = 1
        this.superImposedElements.map((elt) => {
          if (parseInt(elt.style.zIndex) >= maxZindex) {
            maxZindex = parseInt(elt.style.zIndex) + 1
          }
        })
        // set original source position over all group elements
        originalSource.style.zIndex = maxZindex

        // set top left group icon visible on top left element of the group
        if (this.topLeft.element.firstElementChild.id === originalSource.firstElementChild.id) {
          originalSource.firstElementChild.firstElementChild.classList.add("bloc-group-icon--is-visible")
        } else {
          originalSource.firstElementChild.firstElementChild.classList.remove("bloc-group-icon--is-visible")
        }

        // create the new group
        let superImposedElementsIndexes = this.superImposedElements.map((elt) => {
          return parseInt(elt.firstElementChild.id)
        })
        superImposedElementsIndexes.push(parseInt(originalSource.firstElementChild.id))

        newGroups.push(superImposedElementsIndexes)
      } else {
        originalSource.firstElementChild.firstElementChild.classList.remove("bloc-group-icon--is-visible")
        if (!originalSource.classList.contains("bloc--is-groupped")) {
          originalSource.classList.remove("bloc--is-superimposed")
        }
      }

      // update groups : split if needed
      let updatedGroups = updateGroups({
        originalSource,
        newGroups,
        oldGroups: this.options.groups,
        elements: this.elements,
      })

      const smartQGroupEvent = new SmartQGroupEvent({
        newGroups: updatedGroups.newGroups,
        topLeftIndexes: updatedGroups.topLeftIndexes,
      })

      this.draggable.trigger(smartQGroupEvent)
    } else {
      // multi select drag
      if (this.options.selected.length > 1 && this.options.groupSelectedIndex === null) {
        this.selectedMirrors.map(({ source, originalSource }) => {
          source.parentNode.insertBefore(originalSource, source)
          source.parentNode.removeChild(source)
          originalSource.style.display = ""
          source.classList.remove(this.draggable.getClassNameFor("source:dragging"))
          originalSource.classList.remove(this.draggable.getClassNameFor("source:original"))

          // position original source of mirror
          top =
            parseInt(originalSource.firstElementChild.style.top) +
            this.mirrorOffset.top +
            (this.scrollOffset.y ? this.scrollOffset.y : 0)

          originalSource.firstElementChild.style.top = top + "px"

          left = parseInt(originalSource.firstElementChild.style.left) + this.mirrorOffset.left

          originalSource.firstElementChild.style.left = left + "px"

          itemsPosition.push({
            index: parseInt(originalSource.firstElementChild.id),
            top: top,
            left: left,
          })

          // find max zIndex super imposed elements of original source
          let maxZindex = 1
          getSuperImposedElements({ mirror: originalSource, source: originalSource, elements: this.elements }).map(
            (elt) => {
              if (parseInt(elt.style.zIndex) >= maxZindex) {
                maxZindex = parseInt(elt.style.zIndex) + 1
              }
            }
          )
          // set original source position over all group elements
          originalSource.style.zIndex = maxZindex
        })

        // find max zIndex super imposed elements of original source
        let maxZindex = 1
        getSuperImposedElements({ mirror: this.mirror, source, elements: this.elements }).map((elt) => {
          if (parseInt(elt.style.zIndex) >= maxZindex) {
            maxZindex = parseInt(elt.style.zIndex) + 1
          }
        })
        // set original source position over all group elements
        originalSource.style.zIndex = maxZindex

        this.selectedMirrors = []
      } else {
        // group drag
        this.associatedMirrors.map(({ mirror, source, originalSource }) => {
          // reset z-indexes
          mirror.style.zIndex = parseInt(mirror.style.zIndex) - 9999

          // position original source of associated mirrors
          top =
            parseInt(originalSource.firstElementChild.style.top) +
            this.mirrorOffset.top +
            (this.scrollOffset.y ? this.scrollOffset.y : 0)

          originalSource.firstElementChild.style.top = top + "px"

          left = parseInt(originalSource.firstElementChild.style.left) + this.mirrorOffset.left

          originalSource.firstElementChild.style.left = left + "px"

          itemsPosition.push({
            index: parseInt(originalSource.firstElementChild.id),
            top: top,
            left: left,
          })

          originalSource.style.zIndex = mirror.style.zIndex

          source.parentNode.insertBefore(originalSource, source)
          source.parentNode.removeChild(source)
          originalSource.style.display = ""

          source.classList.remove(this.draggable.getClassNameFor("source:dragging"))
          originalSource.classList.remove(this.draggable.getClassNameFor("source:original"))

          mirror.parentNode.removeChild(mirror)
        })

        this.associatedMirrors = []

        // find max zIndex of group's elements
        let maxZindex = 1
        getSuperImposedElements({ mirror: this.mirror, source, elements: this.elements }).map((elt) => {
          if (parseInt(elt.style.zIndex) >= maxZindex) {
            maxZindex = parseInt(elt.style.zIndex) + 1
          }
        })

        // set original source position over all group elements
        originalSource.style.zIndex = maxZindex
      }
    }

    const smartQFreeMoveEvent = new SmartQFreeMoveEvent(itemsPosition)
    this.draggable.trigger(smartQFreeMoveEvent)

    // reset properties
    this.scrollOffset = { x: 0, y: 0 }
    this.initialScrollOffset = { x: 0, y: 0 }
    this.topLeft = {
      top: 100000,
      left: 100000,
      element: null,
    }
    this.elements = []
  }
}

/**
 * Update groups: find if there are splitted groups then create them
 * @param {HTMLElement} originalSource
 * @param {Array} newGroups
 * @param {Array} oldGroups
 * @private
 */
function updateGroups({ originalSource, newGroups, oldGroups, elements }) {
  // eslint-disable-line no-unused-vars
  // console.log('original newGroups')
  // console.log(newGroups)

  // remove bloc--is-superimposed and bloc--is-groupped if source is not part of a group
  if (!newGroups.length) {
    originalSource.classList.remove("bloc--is-superimposed")
    originalSource.classList.remove("bloc--is-groupped")
  }

  if (oldGroups.length) {
    // search for old group containing the source
    let groupWithSourceElement = oldGroups.filter((group) => {
      // if new group just created is the same => false
      if (newGroups.length && group.every((index) => newGroups[0].includes(index))) {
        return false
      }
      return group.includes(parseInt(originalSource.firstElementChild.id))
    })[0]

    // split group
    if (groupWithSourceElement) {
      // clone groupWithSourceElement
      let groupToSplit = groupWithSourceElement.slice()
      // remove source element from group to split
      groupToSplit.splice(groupToSplit.indexOf(parseInt(originalSource.firstElementChild.id)), 1)

      // process only groups with more than 1 element
      if (groupToSplit.length > 1) {
        // search for all possible new groups
        groupToSplit.map((id) => {
          // do not proceed ids already contained in newGroups
          let newGroupsContainsId = false
          newGroups.map((group) => {
            if (group.includes(id)) {
              newGroupsContainsId = true
              return
            }
          })
          if (newGroupsContainsId) {
            return
          }

          let superImposedElements = getSuperImposedElements({ mirror: elements[id], source: null, elements })
          // console.log(superImposedElements)
          if (superImposedElements.length > 1) {
            newGroups.push(superImposedElements.map((elt) => parseInt(elt.firstElementChild.id)))
          } else if (superImposedElements.length === 1) {
            superImposedElements[0].classList.remove("bloc--is-groupped")
            superImposedElements[0].classList.remove("bloc--is-superimposed")
          }
        })
      } else {
        elements[groupToSplit[0]].classList.remove("bloc--is-groupped")
        elements[groupToSplit[0]].classList.remove("bloc--is-superimposed")
      }
    }

    // concat old groups witout source element and not containing newGroups elements to new groups
    let groupsWithoutSourceElement = oldGroups.filter((oldGroup) => {
      let oldGroupContainsNewGroup = false
      newGroups.map((newGroup) => {
        if (oldGroup.every((id) => newGroup.includes(id))) {
          oldGroupContainsNewGroup = true
          return
        }
      })
      return !oldGroupContainsNewGroup && !oldGroup.includes(parseInt(originalSource.firstElementChild.id))
    })

    // console.log('group without')
    // console.log(groupsWithoutSourceElement)
    groupsWithoutSourceElement.map((group) => newGroups.push(group))
    // console.log('newGroups')
    // console.log(newGroups)
  }

  let topLeftIndexes = []
  // find top left elements for each new group
  newGroups.map((group, groupIndex) => {
    let topLeft = {
      top: 100000,
      left: 100000,
      index: null,
    }

    group.map((index) => {
      elements[index].classList.add("bloc--is-groupped")
      let eltRect = elements[index].firstElementChild.getBoundingClientRect()
      if (eltRect.top < topLeft.top) {
        topLeft.left = eltRect.left
        topLeft.top = eltRect.top
        topLeft.index = parseInt(elements[index].firstElementChild.id)
      } else if (eltRect.top === topLeft.top && eltRect.left <= topLeft.left) {
        topLeft.left = eltRect.left
        topLeft.top = eltRect.top
        topLeft.index = parseInt(elements[index].firstElementChild.id)
      }
    })

    topLeftIndexes[groupIndex] = topLeft.index
    elements[topLeft.index].firstElementChild.firstElementChild.classList.add("bloc-group-icon--is-visible")
  })

  return { newGroups, topLeftIndexes }
}

/**
 * Find recursively all mirror's super imposed elements
 * Removing the source (i.e. itself) and already found super imposed elements at each recursive call
 * @param {HTMLElement} mirror
 * @param {HTMLElement} source
 * @param {Array} elements (all grid elements)
 * @return {Array}
 * @private
 */
function getSuperImposedElements({ mirror, source, elements, superImposedElements = [], count = 0 }) {
  let mirrorRect = mirror.firstElementChild.getBoundingClientRect()

  /*if (count === 0) {
    console.log('start')
  }
  console.log('count: '+ count)*/

  let newSuperImposedElements = elements.filter((elt) => {
    if (elt === source || superImposedElements.includes(elt)) {
      return false
    }

    let eltRect = elt.firstElementChild.getBoundingClientRect()

    // test if topLeft mirror corner is in the element
    if (
      mirrorRect.left >= eltRect.left &&
      mirrorRect.left <= eltRect.right &&
      mirrorRect.top >= eltRect.top &&
      mirrorRect.top <= eltRect.bottom
    ) {
      return true
    }

    // test if topRight mirror corner is in the element
    if (
      mirrorRect.right >= eltRect.left &&
      mirrorRect.right <= eltRect.right &&
      mirrorRect.top >= eltRect.top &&
      mirrorRect.top <= eltRect.bottom
    ) {
      return true
    }

    // test if bottomLeft mirror corner is in the element
    if (
      mirrorRect.left >= eltRect.left &&
      mirrorRect.left <= eltRect.right &&
      mirrorRect.bottom >= eltRect.top &&
      mirrorRect.bottom <= eltRect.bottom
    ) {
      return true
    }

    // test if topRigh mirror corner is in the element
    if (
      mirrorRect.right >= eltRect.left &&
      mirrorRect.right <= eltRect.right &&
      mirrorRect.bottom >= eltRect.top &&
      mirrorRect.bottom <= eltRect.bottom
    ) {
      return true
    }
  })

  let result = []
  if (!newSuperImposedElements.length) {
    return []
  } else {
    superImposedElements = superImposedElements.concat(newSuperImposedElements)
    result = result.concat(newSuperImposedElements)
    newSuperImposedElements.map((elt) => {
      result = result.concat(
        getSuperImposedElements({ mirror: elt, source, elements, superImposedElements, count: ++count })
      )
    })

    // remove duplicates
    return result.filter((a, b) => result.indexOf(a) === b)
  }
}

/**
 * Computes mirror dimensions based on the source element
 * Adds sourceRect to state
 * @param {Object} state
 * @param {HTMLElement} state.source
 * @return {Promise}
 * @private
 */
function computeMirrorDimensions({ source, ...args }) {
  // eslint-disable-line no-unused-vars
  return withPromise((resolve) => {
    const sourceRect = source.getBoundingClientRect()
    resolve({ source, sourceRect, ...args })
  })
}

/**
 * Calculates mirror offset
 * Adds mirrorOffset to state
 * @param {Object} state
 * @param {SensorEvent} state.sensorEvent
 * @param {DOMRect} state.sourceRect
 * @return {Promise}
 * @private
 */
function calculateMirrorOffset({ sensorEvent, sourceRect, options, ...args }) {
  // eslint-disable-line no-unused-vars
  return withPromise((resolve) => {
    const top = options.cursorOffsetY === null ? sensorEvent.clientY - sourceRect.top : options.cursorOffsetY
    const left = options.cursorOffsetX === null ? sensorEvent.clientX - sourceRect.left : options.cursorOffsetX

    const mirrorOffset = { top, left }

    resolve({ sensorEvent, sourceRect, mirrorOffset, options, ...args })
  })
}

/**
 * Applys mirror styles
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {HTMLElement} state.source
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function resetMirror({ mirror, source, options, ...args }) {
  // eslint-disable-line no-unused-vars
  return withPromise((resolve) => {
    let offsetHeight
    let offsetWidth

    if (options.constrainDimensions) {
      const computedSourceStyles = getComputedStyle(source)
      offsetHeight = computedSourceStyles.getPropertyValue("height")
      offsetWidth = computedSourceStyles.getPropertyValue("width")
    }

    mirror.style.position = "fixed"
    mirror.style.pointerEvents = "none"
    mirror.style.top = 0
    mirror.style.left = 0
    mirror.style.margin = 0

    if (options.constrainDimensions) {
      mirror.style.height = offsetHeight
      mirror.style.width = offsetWidth
    }

    resolve({ mirror, source, options, ...args })
  })
}

/**
 * Applys mirror class on mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {String} state.mirrorClass
 * @return {Promise}
 * @private
 */
function addMirrorClasses({ mirror, mirrorClass, ...args }) {
  // eslint-disable-line no-unused-vars
  return withPromise((resolve) => {
    mirror.classList.add(mirrorClass)
    resolve({ mirror, mirrorClass, ...args })
  })
}

/**
 * Removes source ID from cloned mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @return {Promise}
 * @private
 */
function removeMirrorID({ mirror, ...args }) {
  // eslint-disable-line no-unused-vars
  return withPromise((resolve) => {
    mirror.removeAttribute("id")
    delete mirror.id
    resolve({ mirror, ...args })
  })
}

/**
 * Positions mirror with translate3d
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {SensorEvent} state.sensorEvent
 * @param {Object} state.mirrorOffset
 * @param {Number} state.initialY
 * @param {Number} state.initialX
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function positionMirror({ withFrame = false, initial = false } = {}) {
  // eslint-disable-line no-unused-vars
  return ({
    mirror,
    sensorEvent,
    mirrorOffset,
    initialY,
    initialX,
    scrollOffset,
    options,
    passedThreshX,
    passedThreshY,
    lastMovedX,
    lastMovedY,
    ...args
  }) => {
    return withPromise(
      (resolve) => {
        const result = {
          mirror,
          sensorEvent,
          mirrorOffset,
          options,
          ...args,
        }

        if (mirrorOffset) {
          const x = passedThreshX
            ? Math.round((sensorEvent.clientX - mirrorOffset.left - scrollOffset.x) / (options.thresholdX || 1)) *
              (options.thresholdX || 1)
            : lastMovedX
          const y = passedThreshY
            ? Math.round((sensorEvent.clientY - mirrorOffset.top - scrollOffset.y) / (options.thresholdY || 1)) *
              (options.thresholdY || 1)
            : lastMovedY

          if ((options.xAxis && options.yAxis) || initial) {
            mirror.style.transform = `translate3d(${x}px, ${y}px, 0)`
          } else if (options.xAxis && !options.yAxis) {
            mirror.style.transform = `translate3d(${x}px, ${initialY}px, 0)`
          } else if (options.yAxis && !options.xAxis) {
            mirror.style.transform = `translate3d(${initialX}px, ${y}px, 0)`
          }

          if (initial) {
            result.initialX = x
            result.initialY = y
          }

          result.lastMovedX = x
          result.lastMovedY = y
        }

        resolve(result)
      },
      { frame: withFrame }
    )
  }
}

/**
 * Wraps functions in promise with potential animation frame option
 * @param {Function} callback
 * @param {Object} options
 * @param {Boolean} options.raf
 * @return {Promise}
 * @private
 */
function withPromise(callback, { raf = false } = {}) {
  // eslint-disable-line no-unused-vars
  return new Promise((resolve, reject) => {
    if (raf) {
      requestAnimationFrame(() => {
        callback(resolve, reject)
      })
    } else {
      callback(resolve, reject)
    }
  })
}
